import React, { useEffect, useState } from "react";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { BiDotsVerticalRounded } from "react-icons/bi";
import FileViewPopup from "./FilesViewPopup";
import EditCandidatePopup from "./EditCandidatePopup";
import { useDispatch } from "react-redux";
import { setAppError, setPage } from "../../../../store/userSlice";
import { FiDownloadCloud } from "react-icons/fi";
import { CgClose, CgSpinner } from "react-icons/cg";
import { axios } from "../../../../Global";
import { HiArrowLongRight } from "react-icons/hi2";
import AgreementGenerator from "./PdfDownload/PdfGenerate";
import { createPortal } from "react-dom";
import { Outlet } from "react-router-dom";

const getSelectedCandidatesDetails = (candidates, selectedCandidates) => {
  const selectedCandidatesDetails = candidates.filter((candidate) =>
    selectedCandidates.some((selected) => selected.id === candidate.id)
  );
  return selectedCandidatesDetails;
};

export default function CandidateList({
  candidates = [],
  allFiletypes,
  setUpdateData,
  titles = [],
  camps,
  arrivalId,
}) {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPage("Arrival Notification/Candidates"));
    return () => dispatch(setPage("Arrival Notification"));
  }, []);

  const arrivedCount = candidates?.filter(
    (candidate) => candidate.arrival_status === "Arrived"
  )?.length;
  const NotArrivedCount = candidates?.filter(
    (candidate) => candidate.arrival_status === "Not Arrived"
  )?.length;
  const missingCount = candidates?.filter(
    (candidate) => candidate.arrival_status === "Missing"
  )?.length;

  const [filesPopupState, setFilesPopupState] = useState({
    open: false,
    id: null,
  });
  const [downloadFilesPopupState, setDownloadFilesPopupState] = useState({
    open: false,
    id: null,
  });
  const { NoDataFound, Pagination, PaginationIndex, Search, currentList } =
    useSearchPagination(candidates || []);

  const [edit, setEdit] = useState({
    open: false,
    isGroup: false,
    value: null,
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [downloadingZip, setDownloadingZip] = useState(false);
  const [downloadPercentage, setDownloadPercentage] = useState(0);
  const [progress, setProgress] = useState(0);
  const handleCheckboxChange = (dataId, isChecked) => {
    setSelectAll(false);
    if (isChecked) {
      setSelectedRows((prevRows) => [...prevRows, { id: dataId }]);
    } else {
      setSelectedRows((prevRows) =>
        prevRows?.filter((row) => row.id !== dataId)
      );
    }
  };
  const handleSelectAllChange = () => {
    setSelectAll((p) => !p);
    if (!selectAll) {
      setSelectedRows(candidates?.map((data) => ({ id: data.id })));
    } else {
      setSelectedRows([]);
    }
  };

  const downloadGroupZip = async () => {
    setDownloadingZip(true);
    setDownloadPercentage(0);
    try {
      const response = await axios.post(
        `/dashboard/arrival-notification/${arrivalId}/candidate-document-zip-file`,
        {
          candidates: selectedRows,
        },
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          onDownloadProgress: (progressEvent) => {
            const percentage =
              (progressEvent.loaded / progressEvent.total) * 100;
            setDownloadPercentage(percentage?.toFixed(0));
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `AllFiles.zip`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "ZIP Downloaded",
            color: "success",
          })
        );
      } else {
        throw new Error("Something went wrong!");
      }
      setDownloadingZip(false);
    } catch (error) {
      setDownloadingZip(false);
      dispatch(
        setAppError({
          msg: error?.response?.data?.message || "Something went wrong",
        })
      );
    }
  };
  console.log(progress, "progress");
  return (
    <>
      {progress == 0 ? (
        <>
          <div className="flex my-2 justify-between  items-center flex-wrap">
            <div>
              <Search
                keywords={[
                  "name",
                  "visa_number",
                  "passport_number",
                  "nationality.name",
                  "age",
                  "job_position.name",
                  "dob",
                  "remark",
                  "border_number",
                  "blood_group",
                  "arrival_status",
                  "camp.name",
                ]}
              />
            </div>
            <div className="hidden lg:inline-block md:inline-block sm:hidden">
              <p className="uppercase text-xl font-semibold">Candidates List</p>
            </div>
            <div>
              <button className="btn btn-sm mr-5 font-bold bg-white text-dark hover:text-white hover:bg-red ">
                DOWNLOAD
              </button>
            </div>
          </div>

          <div className="flex justify-between  flex-wrap mt-3">
            <div className="relative">
              <button
                className={` text-white flex items-center gap-3 text-sm lg:text-base md:text-base  rounded-md p-2 peer ${
                  selectedRows?.length > 0
                    ? "bg-blue"
                    : "bg-blue/50 pointer-events-none"
                }`}
                disabled={downloadingZip}
              >
                Group Action
                {downloadingZip ? (
                  <CgSpinner className="animate-spin" />
                ) : (
                  <HiArrowLongRight size={"1.2rem"} />
                )}
              </button>
              <div className="hidden absolute bottom-10  max-w-xs w-[17rem] h-auto bg-white shadow-xl rounded-lg p-2 dark:bg-dark2 ring-1 ring-slate-400 dark:ring-black peer-hover:block hover:block">
                <button
                  className="w-full"
                  onClick={() =>
                    setEdit({ open: true, value: selectedRows, isGroup: true })
                  }
                  disabled={downloadingZip}
                >
                  <p className="bg-white shadow-sm  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                    Edit
                    <HiArrowLongRight size={"1.2rem"} />
                  </p>
                </button>
                <button
                  className="w-full"
                  onClick={() => downloadGroupZip()}
                  disabled={selectedRows?.length > 10 || downloadingZip}
                  title={`${
                    selectedRows?.length > 10
                      ? "Select less than 10 candidates."
                      : ""
                  }`}
                >
                  <p
                    className={`bg-white shadow-sm  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-4 ${
                      selectedRows?.length > 10 ? " hover:bg-rose-400" : ""
                    }`}
                  >
                    {downloadingZip ? (
                      <>Downloading ZIP {downloadPercentage}%</>
                    ) : (
                      <>
                        Download ZIP <HiArrowLongRight size={"1.2rem"} />
                      </>
                    )}
                  </p>
                </button>
                <AgreementGenerator
                  setProgress={setProgress}
                  progress={progress}
                  selectedRows={selectedRows}
                  candidates={getSelectedCandidatesDetails(
                    candidates,
                    selectedRows
                  )}
                />
              </div>
            </div>
            <div className="text-sm uppercase mt-2 lg:text-base rounded-lg shadow bg-white font-bold pt-4 pb-2 px-5">
              <p>
                Arrived: {arrivedCount}&nbsp;|&nbsp;Not Arrived:{" "}
                {NotArrivedCount}
                &nbsp;|&nbsp;Missing: {missingCount}
              </p>
            </div>
            <p className="text-sm w-full uppercase text-right font-medium my-3 block">{`Slide / scroll to right >`}</p>
          </div>
          <div className="p-5 pt-11 w-full bg-white overflow-x-scroll lg:overflow-auto">
            {filesPopupState.open && (
              <FileViewPopup
                setUpdateData={setUpdateData}
                filesPopupState={filesPopupState}
                setFilesPopupState={setFilesPopupState}
                filesData={
                  candidates.find(
                    (candidate) => candidate?.id == filesPopupState?.id
                  )?.candidate_file
                }
                allFiletypes={allFiletypes}
                arrivalId={arrivalId}
                // setCallUpdatedListData={setCallUpdatedListData}
              />
            )}
            {downloadFilesPopupState.open && (
              <DownloadFilesView
                downloadFilesPopupState={downloadFilesPopupState}
                setDownloadFilesPopupState={setDownloadFilesPopupState}
              />
            )}

            {edit && (
              <EditCandidatePopup
                setUpdateData={setUpdateData}
                edit={edit}
                setEdit={setEdit}
                camps={camps}
                candidates={candidates}
                arrivalId={arrivalId}
              />
            )}

            <div
              className={` text-sm lg:text-base uppercase grid justify-items-center grid-cols-table-global-arrival-notification auto-cols-min gap-5 p-6 bg-white w-full  items-baseline  rounded-md `}
            >
              {titles?.map((title, index) => (
                <p key={index} className="font-semibold uppercase">
                  {" "}
                  {title == "Select" ? (
                    <div className="flex gap-2 items-center">
                      {title}
                      <input
                        type="checkbox"
                        className="checkbox checkbox-sm checkbox-error"
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                    </div>
                  ) : (
                    title
                  )}
                </p>
              ))}
              <NoDataFound customClass="col-span-8" />
              {candidates?.length <= 0 && (
                <p className="col-span-8">No Data found</p>
              )}
              {currentList?.map((candidate, index) => (
                <React.Fragment key={candidate?.id}>
                  <PaginationIndex index={index} />
                  <input
                    type="checkbox"
                    className="checkbox"
                    onChange={(e) =>
                      handleCheckboxChange(candidate?.id, e.target.checked)
                    }
                    checked={
                      selectAll ||
                      selectedRows.some((row) => row.id === candidate?.id)
                    }
                  />
                  <p>{candidate?.name || "--"}</p>
                  <p>{candidate?.nationality?.name || "--"}</p>
                  <p>{candidate?.visa_number || "--"}</p>
                  <p>{candidate?.passport_number || "--"}</p>
                  <p>{candidate?.border_number || "--"}</p>
                  <p>{candidate?.job_position?.name || "--"}</p>
                  <p>{candidate?.dob || "--"}</p>
                  <p>{candidate?.age || "--"}</p>
                  <p>{candidate?.blood_group || "--"}</p>
                  <p>{candidate?.remark || "--"}</p>
                  <p>{candidate?.arrival_status || "--"}</p>
                  <p>{candidate?.camp?.name || "--"}</p>
                  <a
                    href={candidate?.google_map_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {candidate?.google_map_link || "--"}
                  </a>
                  <div className="flex">
                    <div className="relative">
                      <button className="rounded-md bg-white p-2 text-sm text-black peer ">
                        <BiDotsVerticalRounded size={"1.4rem"} />
                      </button>

                      <div className=" hidden absolute bottom-0 right-7 max-w-xs w-[17rem] h-auto bg-white shadow-xl rounded-lg p-2 dark:bg-dark2 ring-1 ring-slate-400 dark:ring-black peer-hover:block hover:block">
                        <button
                          className="w-full"
                          onClick={() =>
                            setEdit({
                              open: true,
                              candidate: candidate,
                              isGroup: false,
                              value: [{ id: candidate?.id }],
                            })
                          }
                        >
                          <p className="bg-white shadow-sm uppercase  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                            Edit
                          </p>
                        </button>
                        <button
                          onClick={() =>
                            setFilesPopupState({
                              open: true,
                              id: candidate?.id,
                            })
                          }
                          className="w-full"
                        >
                          <p className="bg-white uppercase p-2 w-full hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                            Files
                          </p>
                        </button>
                      </div>
                    </div>
                    <div className="">
                      <button
                        className="rounded-md bg-white p-2 text-sm text-black peer "
                        onClick={() => {
                          setDownloadFilesPopupState({
                            open: true,
                            arrivalId,
                            candId: candidate?.id,
                          });
                        }}
                      >
                        <FiDownloadCloud size={"1.4rem"} />
                      </button>
                    </div>
                  </div>

                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))}
            </div>
          </div>
          <Pagination />
        </>
      ) : (
        <h1>Your data is downloading in another page</h1>
      )}
    </>
  );
}

// createPortal(
//   <div className="absolute bottom-0 right-0 pt-1">
//     <div className="flex mb-2 items-center justify-between">
//       <div>
//         <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-teal-600 bg-teal-200">
//           In Progress
//         </span>
//       </div>
//       <div className="text-right">
//         <span className="text-xs font-semibold inline-block text-teal-600">
//           {`${progress}%`}
//         </span>
//       </div>
//     </div>
//     <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-teal-200">
//       <div
//         style={{ width: `${progress}%` }}
//         className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-teal-500"
//       ></div>
//     </div>
//   </div>,
//   document.body
// )
function DownloadFilesView({
  downloadFilesPopupState,
  setDownloadFilesPopupState,
}) {
  const candId = downloadFilesPopupState?.candId;
  const arrivalId = downloadFilesPopupState?.arrivalId;
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  const [downloading, setDownloading] = useState({ active: false, type: null });

  const downloadFile = async (docType) => {
    setDownloading({ active: true, type: docType });
    try {
      const response = await axios.get(
        `/dashboard/arrival-notification/${arrivalId}/candidate-document/${candId}/${docType}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${docType} PDF`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "PDF Downloaded",
            color: "success",
          })
        );
      } else {
        throw new Error("Something went wrong!");
      }
      setDownloading({ active: false, type: null });
    } catch (error) {
      setDownloading({ active: false, type: null });
      dispatch(setAppError({ msg: error?.response?.data?.message }));
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        downloadFilesPopupState.open ? "flex" : "hidden"
      }`}
    >
      <div className="p-5 bg-white">
        <div
          className="flex justify-between"
          onClick={() => setDownloadFilesPopupState({ open: false })}
        >
          <div className="text-2xl font-bold">Download</div>
          <div className=" cursor-pointer p-3">
            <CgClose />
          </div>
        </div>
        <div className="max-w-xs w-[17rem] h-auto bg-white  rounded-lg p-2 dark:bg-dark2 ring-1 ring-slate-400 dark:ring-black peer-hover:block hover:block">
          <button
            className="w-full"
            disabled={downloading?.active}
            onClick={() => downloadFile("emp_contract")}
          >
            <p className="bg-white shadow-sm  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
              Employment Contract
              {downloading?.active && downloading?.type === "emp_contract" ? (
                <CgSpinner className="animate-spin" />
              ) : (
                <HiArrowLongRight size={"1.2rem"} />
              )}
            </p>
          </button>
          <button
            className="w-full"
            onClick={() => downloadFile("absenteeism")}
            disabled={downloading?.active}
          >
            <p className="bg-white shadow-sm  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
              Absenteeism
              {downloading?.active && downloading?.type === "absenteeism" ? (
                <CgSpinner className="animate-spin" />
              ) : (
                <HiArrowLongRight size={"1.2rem"} />
              )}
            </p>
          </button>
          <button
            className="w-full"
            onClick={() => downloadFile("cash_advance")}
            disabled={downloading?.active}
          >
            <p className="bg-white shadow-sm  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
              Cash Advance Form
              {downloading?.active && downloading?.type === "cash_advance" ? (
                <CgSpinner className="animate-spin" />
              ) : (
                <HiArrowLongRight size={"1.2rem"} />
              )}
            </p>
          </button>
        </div>
      </div>
    </div>
  );
}
